import axios from "axios";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

export const nav = [
  { id: "dashboard", label: "Command center", group: "Overview" },
  { id: "livemap", label: "Live map", group: "Overview" },
  { id: "sentiment", label: "Sentiment map", group: "Overview" },
  { id: "digest", label: "Weekly digest", group: "Overview" },
  { id: "people", label: "People", group: "Core CRM" },
  { id: "adminmembers", label: "Admin & Members", group: "Core CRM" },
  { id: "households", label: "Households", group: "Core CRM" },
  { id: "organizations", label: "Organizations", group: "Core CRM" },
  { id: "voterroll", label: "Voter roll OCR", group: "Core CRM" },
  { id: "electionday", label: "Election day", group: "Core CRM" },
  { id: "complaints", label: "Complaints", group: "Grievance" },
  { id: "promises", label: "Promises", group: "Grievance" },
  { id: "tasks", label: "Tasks", group: "Fieldwork" },
  { id: "field", label: "Field visits", group: "Fieldwork" },
  { id: "volunteers", label: "Volunteers", group: "Fieldwork" },
  { id: "chat", label: "Booth chat", group: "Fieldwork" },
  { id: "campaigns", label: "Campaigns", group: "Outreach" },
  { id: "events", label: "Programs & events", group: "Outreach" },
  { id: "broadcasts", label: "Broadcasts", group: "Outreach" },
  { id: "communicate", label: "Communicate", group: "Outreach" },
  { id: "forms", label: "Custom forms", group: "Outreach" },
  { id: "advice", label: "Advice blog", group: "Outreach" },
  { id: "schemes", label: "Govt schemes", group: "Governance" },
  { id: "finance", label: "Finance", group: "Governance" },
  { id: "audit", label: "Audit log", group: "Governance" },
  { id: "leaderboard", label: "Leaderboard", group: "Governance" },
  { id: "boothowners", label: "Booth responsible", group: "Governance", superAdminOnly: true },
  { id: "duplicates", label: "Duplicates", group: "Governance", superAdminOnly: true },
  { id: "recyclebin", label: "Recycle bin", group: "Governance", superAdminOnly: true },
  { id: "tenant", label: "White-label & plan", group: "Governance" },
  { id: "system", label: "System settings", group: "Governance", superAdminOnly: true },
];

export const inclinationColor = { Supporter: "green", Neutral: "blue", Undecided: "amber", Opposition: "red", "BJP Worker": "amber", "TMC Worker": "green", "CPIM Worker": "red" };
export const INCLINATION_OPTIONS = ["Supporter", "Neutral", "Undecided", "Opposition", "BJP Worker", "TMC Worker", "CPIM Worker"];
export const statusColor = {
  Verified: "green", Incomplete: "amber",
  Lodged: "amber", Acknowledged: "blue", Verified2: "blue",
  Solving: "amber", Solved: "green", Closed: "green", Reopened: "red",
  Open: "amber", "In Progress": "blue", Done: "green",
  Active: "green", Planned: "blue", Draft: "amber", Sent: "green", Scheduled: "blue",
  Initiated: "amber", Fulfilled: "green", Delayed: "red",
};
export const priorityColor = { Urgent: "red", High: "amber", Medium: "blue", Low: "green" };
